import BetaForm from "@/components/landing/BetaForm";

export default function CTAFooter() {
  return (
    <footer
      data-testid="footer"
      className="bg-cream relative overflow-hidden border-t hairline"
    >
      {/* Massive marquee word */}
      <div className="border-b hairline overflow-hidden">
        <div className="marquee-track py-8 md:py-14">
          {Array.from({ length: 2 }).map((_, k) => (
            <div key={k} className="flex items-center gap-16 px-6 whitespace-nowrap">
              {Array.from({ length: 6 }).map((__, i) => (
                <span key={`${k}-${i}`} className="flex items-center gap-16">
                  <span className="font-serif italic text-[14vw] md:text-[10vw] leading-none text-ink">
                    Ovamx
                  </span>
                  <span className="text-coral text-3xl md:text-5xl">✦</span>
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>

      {/* Final CTA */}
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-24 md:py-36 grid grid-cols-12 gap-8">
        <div className="col-span-12 md:col-span-7">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-coral">
            ◊ Acceso anticipado
          </p>
          <h2 className="mt-5 font-serif text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tighter">
            Sé fundador<br />
            <span className="italic">temprano de Ovamx.</span>
          </h2>
          <p className="mt-6 max-w-xl text-lg text-ink/75 leading-relaxed">
            Los primeros 100,000 usuarios reciben verificación gratuita de por vida, comisión 0% en el marketplace durante el primer año y acceso prioritario a la IA Pro.
          </p>
          <div className="mt-10">
            <BetaForm />
          </div>
        </div>

        <div className="col-span-12 md:col-span-4 md:col-start-9 md:pt-12 space-y-10">
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-ink-mid">
              Manifiesto
            </p>
            <ul className="mt-3 space-y-2 text-sm text-ink/80">
              <li>· Tu atención no se vende.</li>
              <li>· Tu identidad se respeta.</li>
              <li>· Tu creatividad se paga.</li>
              <li>· Tu mundo se expande.</li>
            </ul>
          </div>

          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-ink-mid">
              Producto
            </p>
            <ul className="mt-3 space-y-2 text-sm">
              <li><a href="#feed" className="link-underline">Feed Dual</a></li>
              <li><a href="#monetizacion" className="link-underline">Monetización</a></li>
              <li><a href="#ia" className="link-underline">IA & Viajes</a></li>
              <li><a href="#privacidad" className="link-underline">Privacidad</a></li>
              <li><a href="#vision" className="link-underline">Visión 2030</a></li>
            </ul>
          </div>

          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-ink-mid">
              Contacto
            </p>
            <ul className="mt-3 space-y-2 text-sm">
              <li><a href="mailto:hello@ovamx.com" className="link-underline">hello@ovamx.com</a></li>
              <li><a href="mailto:investors@ovamx.com" className="link-underline">investors@ovamx.com</a></li>
              <li><a href="mailto:press@ovamx.com" className="link-underline">press@ovamx.com</a></li>
            </ul>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-ink-mid mt-6">
              Legal
            </p>
            <ul className="mt-3 space-y-2 text-sm">
              <li><a href="/legal/terminos" className="link-underline" data-testid="footer-terms">Términos</a></li>
              <li><a href="/legal/privacidad" className="link-underline" data-testid="footer-privacy">Privacidad</a></li>
              <li><a href="/legal/cookies" className="link-underline" data-testid="footer-cookies">Cookies</a></li>
              <li><a href="/legal/politica-uso" className="link-underline" data-testid="footer-policy">Política de Uso</a></li>
              <li><a href="/mision-vision-valores" className="link-underline" data-testid="footer-mvv">Misión y Valores</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t hairline">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 font-mono text-[10px] uppercase tracking-[0.25em] text-ink-mid">
          <p>© 2026 Ovamx · Construido con principios, no con concesiones.</p>
          <p>v0.1 · landing manifesto · made in earth</p>
        </div>
      </div>
    </footer>
  );
}
